<template>
  <div class="productDetails">
    <h1>{{ product.name }}</h1>
    <div class="details">
      <!-- left -->
      <div>
        <div class="image">
          <img :src="product.image" alt="" />
        </div>
        <div class="quantity">
          <button @click="doAddToCart" :disabled="cartQuantity >= 5">
            <button><img src="./add.svg" /></button>
          </button>
          {{ cartQuantity }}
          <button @click="doRemoveFromCart" :disabled="!cartQuantity > 0">
            <button><img src="./minus.svg" /></button>
          </button>
        </div>
      </div>
      <!-- right -->
      <div class="right">
        <div class="property highlight">
          <div class="key">Price :</div>
          <div class="value">Rs {{ product.price }} /-</div>
        </div>
        <div class="property">
          <div class="key">
            Gender :
          </div>
          <div class="value">
            <div v-bind:key="g" v-for="(gen, g) in product.gender">
              {{ gen }}
            </div>
          </div>
        </div>
        <div class="property">
          <div class="key">
            Available Size :
          </div>
          <div class="value">
            <div v-bind:key="s" v-for="(size, s) in product.size">
              {{ size }}
            </div>
          </div>
        </div>
        <div class="property">
          <div class="key">
            For Age :
          </div>
          <div class="value">
            <div v-bind:key="a" v-for="(age, a) in product.age">
              {{ age }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment">
      <input
        v-model="reviewInput"
        type="textarea"
        placeholder="Write your review here..."
      />
      <button class="submit" @click.prevent="review()">Submit</button>
      <div class="review" v-bind:key="r" v-for="(rev, r) in reviews">
        <div class="rev">
          <p>{{ rev.username }}</p>
          <br />
          {{ rev.comment }}
          <!-- {{rev}} -->
        </div>
        <div class="revButton">
          <p>{{ rev.date }}</p>
          <br />
          <button><img src="./like.svg" /></button>
          <button><img src="./dislike.svg" /></button>
        </div>
      </div>
      <!-- 1 function bnega jo sort krega on the basis of counter -->
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      reviewInput: "",
      product: {},
      reviews: [],
    };
  },
  computed: {
    cartQuantity() {
      return this.$store.state.cart[this.product._id] || 0;
    },
  },
  methods: {
    ...mapMutations(["addToCart"]),
    async getProduct(id) {
      return new Promise((res) => {
        this.axios.get(`product/${id}`).then((response) => {
          res(response.data);
        });
      });
    },
    doAddToCart() {
      this.addToCart({ productId: this.product._id, quantity: 1 });
    },
    doRemoveFromCart() {
      this.addToCart({ productId: this.product._id, quantity: -1 });
    },
    review() {
      this.reviews.push({
        username: atob(localStorage.getItem("user").split(" ")[1]).split(
          ":"
        )[0],
        comment: this.reviewInput,
        date: "Jun 05 2020",
        upvote: 0,
        downvote: 0,
      });
    },
  },
  async created() {
    const id = this.$route.query.id;
    const data = await this.getProduct(id);
    if (Object.keys(data).length === 0) {
      this.$router.push("/");
    } else this.product = data;
  },
};
</script>

<style lang="scss" scoped>
.productDetails {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    padding-bottom: 40px;
    :first-child {
      display: grid;
      justify-items: center;
      .image {
        // background-color: #2c3e50;
        width: 200px;
        height: 200px;
        img {
          display: block;
          max-width: 100%;
          max-height: 100%;
          margin-left: auto;
          margin-right: auto;
        }
      }

      .quantity {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 10px;
        button {
          background: transparent;
          border: 0;
          padding: 5px;
          img {
            height: 15px;
            width: 15px;
          }
        }
      }
    }

    :last-child {
      .property {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .value {
          display: flex;
          margin: 5px;
          * {
            // border: 1px solid #2c3e50;
            background-color: lightgrey;
            padding: 5px;
            margin: 5px;
          }
        }
      }
    }
  }

  .comment {
    input {
      background-color: #f7f7f7;
      border: 1px solid #5479aa;
      color: #2c3e50;
      height: 40px;
      width: 300px;
      text-align: center;
    }
    button {
      border: 0;
      background-color: transparent;
      :hover {
        height: 23px;
        width: 23px;
      }
    }
    img {
      height: 20px;
      width: 20px;
    }
    .submit {
      margin: 20px;
      padding: 5px 10px;
      font-weight: normal;
      font-size: 0.9em;
      letter-spacing: 0.5px;
      border: 1px transparent;
      border-radius: 5px;
      color: #f7f7f7;
      background-color: #2c3e50;
    }
    .review {
      display: flex;
      justify-content: space-between;
      margin: 20px;
      .rev {
        p {
          margin: 0;
          color: #5479aa;
          font-size: 1em;
          font-weight: bold;
        }
      }
      .revButton {
        margin-bottom: 20px;
        p {
          margin: 0;
          color: gray;
        }
      }
    }
  }

  .right {
    padding: 15px 30px;
    border: 1px solid #5479aa;
  }
  .highlight {
    padding: 3px;
    // border: 1px solid #2c3e50;
    height: 30px;
    width: 150px;
    background-color: lightgrey;
    font-size: 1.2em;
    font-weight: bold;
  }
}
</style>
